import { css } from "@compiled/react";

import { Button } from "@/libraries/design/components";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import { useSiteActivationContext } from "../../hooks/site-activation-context";

export const SubmitButton = ({ submitMessage }: { submitMessage: string }) => {
    const { isSubmitting, hasSubmitted } = useSiteActivationContext();
    const visualFeedback = checkFeatureFlagGate(
        featureFlags.signupVisualAlignmentFeedback
    );
    return (
        <Button
            css={[buttonCss, visualFeedback && buttonVisualFeedbackCss]}
            type="submit"
            isDisabled={isSubmitting || hasSubmitted}
            isLoading={isSubmitting || hasSubmitted}
        >
            {submitMessage}
        </Button>
    );
};

const buttonCss = css({
    fontFamily: "inherit",
    fontSize: 16,
    maxWidth: "auto",
    paddingBlock: 8,
    width: "100%"
});

const buttonVisualFeedbackCss = css({
    borderRadius: 6,
    fontSize: 14
});
